module.exports = __webpack_public_path__ + "static/weird_tank-6a4baac908ce48faf4d28b36536fe52d.png";